<template>
  <div class="simple-categories">
    <div class="chips-category">
      <div class="text-wrapper">Tout</div>
    </div>

    <div class="chips-category">
      <div class="text-wrapper">Fruits</div>
    </div>

    <div class="chips-category">
      <div class="text-wrapper">Légumes</div>
    </div>

    <div class="div">
      <div class="active">Épices/grains</div>
      <img
        class="iconamoon-close"
        alt="Iconamoon close"
        src="/img/iconamoon-close-light.svg"
      />
    </div>

    <div class="div">
      <div class="active">Vanille</div>
      <img
        class="iconamoon-close"
        alt="Iconamoon close"
        src="/img/iconamoon-close-light.svg"
      />
    </div>

    <div class="chips-category">
      <div class="text-wrapper">Huiles végétales</div>
    </div>

    <div class="div">
      <div class="active">Huiles essentielles</div>
      <img
        class="iconamoon-close"
        alt="Iconamoon close"
        src="/img/iconamoon-close-light.svg"
      />
    </div>

    <div class="chips-category">
      <div class="text-wrapper">Plantes médicinales</div>
    </div>

    <div class="chips-category">
      <div class="text-wrapper">Plantes cosmétiques</div>
    </div>

    <div class="chips-category">
      <div class="text-wrapper">Certification</div>
    </div>

    <div class="chips-category">
      <div class="text-wrapper">Textiles</div>
    </div>

    <div class="chips-category">
      <div class="text-wrapper">Fertilisants</div>
    </div>

    <div class="chips-category">
      <div class="text-wrapper">Autres</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleCategories",
};
</script>

<style>
.simple-categories {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 10px;
  /* left: 247px; */
  padding: 10px;
  margin: 0px 8vw;

  /* position: absolute; */
  /* top: 237px; */
  /* width: 1368px; */
}

.simple-categories .chips-category {
  align-items: center;
  border: 1px solid;
  border-color: #163518;
  border-radius: 8px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  justify-content: center;
  padding: 12px 32px;
  position: relative;
}

.simple-categories .text-wrapper {
  color: #163518;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 15px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: -1.00px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.simple-categories .div {
  align-items: center;
  background-color: #507249;
  border-radius: 8px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  justify-content: center;
  padding: 12px 12px 12px 32px;
  position: relative;
}

.simple-categories .active {
  color: #e6e3b5;
  font-family: "Mona-Sans-SemiBold", Helvetica;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: -1.00px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.simple-categories .iconamoon-close {
  height: 24px;
  position: relative;
  width: 24px;
}
</style>